module.exports = __webpack_public_path__ + "static/media/slider2.e32cc8ff.jpg";